import React, {createContext, useContext, useRef} from 'react';
import {Toast} from 'primereact/toast';

interface ToastContextProps {
  showSuccess: (summary: string, detail?: string) => void;
  showError: (summary: string, detail?: string) => void;
}

const ToastContext = createContext<ToastContextProps | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
  const toast = useRef<Toast>(null);

  const showSuccess = (summary: string, detail?: string) => {
    toast.current?.show({severity: 'success', summary, detail, life: 3000});
  };

  const showError = (summary: string, detail?: string) => {
    toast.current?.show({severity: 'error', summary, detail, life: 5000});
  };

  return (
    <ToastContext.Provider value={{showSuccess, showError}}>
      <Toast ref={toast}/>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
